<!--
 * @Author: wangbaihe
 * @Date: 2024-06-19 16:48:19
 * @LastEditors: wangbaihe
 * @LastEditTime: 2025-06-026 18:50:11
 * @FilePath: \main\src\components\GlobalFloatingCube.vue
 * @Description: 修改为悬浮机器人，鼠标悬浮出现魔方和知识问答入口按钮
-->

// 悬浮按钮组件
<template>
  <div>
    <KnowledgeQARenderer
      :knowledge-type="knowledgeType"
      v-if="showKnowledge"
      v-show="knowledgeVisible"
      @closed="() => constrolKnoledge(false)"
    />
    <div id="GlobalFloatingCube" v-if="visible">
      <div class="button-box" v-drag:mousemove="mousemove" draggable="false">
        <div
          class="ai-dialog"
          :style="`height:${getContainerStyle + 30}px;top:-${
            getContainerStyle + 30
          }px`"
        >
          <div :style="`height:${getContainerStyle}px`">
            <div
              class="ai-knowledge"
              v-if="knoledgeOpAuth"
              @click="() => constrolKnoledge(true, 1)"
            >
              <img src="../assets/img/aiOp.png" />
            </div>
            <div
              class="ai-knowledge"
              v-if="knoledgeAuth"
              @click="() => constrolKnoledge(true, 0)"
            >
              <img src="../assets/img/ai.png" />
            </div>
            <template v-if="cubeAuth">
              <div
                v-if="cubeLogo()"
                class="btn-bg-customor"
                @click="handleClick"
                :style="{ backgroundImage: 'url(' + cubeLogo() + ')' }"
              ></div>
              <div v-else class="btn-bg-img" @click="handleClick"></div>
            </template>
          </div>
        </div>

        <img class="robot-icon" src="../assets/img/robot.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { MediaCloudSystemThirdparty } from '@apis'
import KnowledgeQARenderer from './KnowledgeQARenderer/index.vue'
export default {
  name: 'GlobalFloatingCube',
  components: {
    KnowledgeQARenderer // 知识问答
  },
  props: {
    auths: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      knoledgeAuth: false, // 是否有知识问答权限
      cubeAuth: false, // 是否有魔方权限
      isMove: false,
      isPUGC: false,
      showKnowledge: false, // 是否渲染知识问答
      knowledgeVisible: false, // 是否显示知识问答
      knowledgeType: 0, // 知识问答类型（0--知识问答，1--运维助手）
      containerStyle: '' // 容器的高度
    }
  },
  watch: {
    $route: {
      handler: function (val) {
        this.getFloatAuths(val)
      },
      immediate: true
    }
  },
  mounted() {
    // 判断当前是否PUGC投稿平台
    this.isPUGC = process.env.MODE === 'PUGC'
    if (this.auths.includes('client-knowledge-answers')) {
      this.knoledgeAuth = true
    }
    this.getFloatAuths(this.$route)
  },
  computed: {
    // 是否有运维助手权限
    knoledgeOpAuth() {
      return this.$eventBus.getData(
        this.$eventBusDataKey.AUTH.AI_ASSISTANT_SWITCH
      )
    },
    /**
     * 获取容器样式
     */
    getContainerStyle() {
      let height = 0
      if (this.knoledgeAuth) {
        height += 60
      }
      if (this.knoledgeOpAuth) {
        height += 60
      }
      if (this.cubeAuth) {
        height += 60
      }
      return height
    }
  },
  methods: {
    /**
     * 获取悬浮层区域的权限
     */
    getFloatAuths(val) {
      this.cubeAuth = localStorage.getItem('yqMagicCubeCreator')
      let yqMagicCubeCreator = localStorage.getItem('yqMagicCubeCreator')
      if (!val || (!yqMagicCubeCreator && !this.knoledgeAuth)) {
        // 处理 $route 为空的情况
        this.visible = false
        return
      }
      if (['Login', 'Error'].includes(val?.name)) {
        this.visible = false
      } else if (
        val?.path === '/' ||
        val?.path.includes('/open/') ||
        val?.path.includes('/noticeDetail')
      ) {
        this.visible = false
      } else {
        let loginInfo = localStorage.getItem('loginInfo')

        setTimeout(() => {
          if (loginInfo) {
            if (this.isPUGC) {
              this.visible = false
            } else {
              this.visible = yqMagicCubeCreator || this.knoledgeAuth
            }
          } else {
            this.visible = false
          }
        }, 500)
      }
    },
    /**
     * 是否显示知识问答浮层
     * @param {Boolean} tag 是否显示
     * @param {Number} type 类型 0--知识问答，1--运维助手
     */
    constrolKnoledge(tag, type) {
      // 先关闭，在开启
      this.showKnowledge = false
      if (tag) {
        this.$nextTick(() => {
          this.showKnowledge = true
          this.knowledgeVisible = tag
          this.knowledgeType = type
        })
      }
    },
    cubeLogo() {
      return localStorage.getItem('yqMagicCubeCreatorLogo') || ''
    },
    handleClick(event) {
      if (this.isMove) {
        event.preventDefault()
        // console.log('拖拽')
      } else {
        // console.log('点击')
        this.getCubeOpenPath()
      }
    },
    getCubeOpenPath() {
      MediaCloudSystemThirdparty.getNewairCloudLogin({}).then((resp) => {
        if (resp.data.status === 0) {
          // console.log('resp', resp.data.data)
          window.open(resp.data.data, '_blank')
        } else {
          console.log('魔方链接获取失败')
        }
      })
    },
    mousemove(isMove, now) {
      if (isMove) {
        this.isMove = isMove
      } else {
        if (!now) {
          setTimeout(() => {
            this.isMove = isMove
          }, 50)
        } else {
          this.isMove = isMove
        }
      }
    }
  },
  directives: {
    drag(el, binding) {
      let oDiv = el // 当前元素
      const mousemove = binding.value
      // let self = this // 上下文
      // 禁止选择网页上的文字
      // document.onselectstart = function() {
      //   return false
      // }

      oDiv.onmousedown = function (e) {
        // 鼠标按下，计算当前元素距离可视区的距离
        let disX = e.clientX - oDiv.offsetLeft
        let disY = e.clientY - oDiv.offsetTop
        let MaxX = 0,
          MaxY = 0
        let l, t
        oDiv.classList.add('dragging')
        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          l = e.clientX - disX
          t = e.clientY - disY
          let Ml = l >>> 0
          let Mt = t >>> 0
          MaxX = Math.max(MaxX, Ml)
          MaxY = Math.max(MaxY, Mt)

          // 移动当前元素
          oDiv.style.left = l + 'px'
          oDiv.style.top = t + 'px'
          mousemove(true)
        }
        document.onmouseup = function (e) {
          oDiv.classList.remove('dragging')
          document.onmousemove = null
          document.onmouseup = null

          mousemove(false)

          let left = document.documentElement.clientWidth - l - 90
          let top = 0
          if (t < 180) {
            top = 180 - t
          } else if (t > document.documentElement.clientHeight - 120) {
            top = document.documentElement.clientHeight - 120 - t
          } else {
            top = 0
          }
          oDiv.style.transform = `translate(${left}px, ${top}px)`
          // oDiv.style.left = left + 'px'
        }

        // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#GlobalFloatingCube {
  position: relative;
  cursor: pointer;
  z-index: 999;
  ::v-deep .dragging {
    transform: scale(1.1);
  }
  .button-box {
    width: 124px;
    border-radius: 50%;
    position: fixed;
    top: calc(100% - 180px);
    right: 20px;
    cursor: pointer;
    transition: transform 0.3s ease-out;
    display: flex;
    flex-direction: column;
    align-items: center;
    &:hover {
      .ai-dialog {
        pointer-events: all;
        & > div {
          opacity: 1;
          top: 20px;
        }
      }
    }
    .robot-icon {
      width: 124px;
    }
    .ai-dialog {
      height: 155px;
      overflow: hidden;
      position: absolute;
      width: 70px;
      display: flex;
      pointer-events: none;
      justify-content: center;
      top: -155px;
      & > div {
        transition: all 0.3s ease-out;
        height: 122px;
        display: flex;
        opacity: 0;
        top: 120%;
        background: #ffffff;
        box-shadow: 1px 0px 10px 0px #0057b8;
        border-radius: 27px 27px 27px 27px;
        width: 54px;
        text-align: center;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        padding: 10px 0;
        position: absolute;
        .ai-knowledge {
          img {
            width: 26px;
          }
        }
      }
    }
  }
  .btn-bg-img {
    width: 26px;
    height: 26px;
    background-image: url('../assets/img/aiDialoguePic.gif');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .btn-bg-customor {
    width: 26px;
    height: 26px;
    // background-image: url('../assets/img/aiDialoguePic.gif');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .button-box:hover {
    color: white;
    opacity: 1;
  }
}
</style>
